import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/index'
import VueAnalytics from 'vue-analytics'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'
import firebase from 'firebase'
import firebaseConfig from './utils/firebase'
import VueResource from 'vue-resource'
import { API_KEY } from '@/config'
import storePlugin from '@/storePlugin'

Vue.use(storePlugin)

require('firebase/firestore')
window.Vue = Vue
Vue.config.productionTip = false

function isTokenExpired (state) {
  return (!state.auth.tokenExpiration) || new Date() > new Date(state.auth.tokenExpiration - 5000)
}

function checkTokenExpired () {
  if (store.state.auth.tokenExpiration) {
    if (isTokenExpired(store.state)) {
      store.dispatch('errors/pushError', {error: 'Session timed out, please login again'})
      store.dispatch('auth/logout')
      router.push({name: 'home'})
    }
  }
}

function configureVueResource () {
  Vue.use(VueResource)
  Vue.http.options.root = 'https://www.bungie.net/'
  Vue.http.interceptors.push((request, next) => {
    request.headers.set('X-Api-Key', API_KEY)
    const bungieToken = store.state.auth.bungieToken
    if (bungieToken && request.url !== 'Platform/App/OAuth/Token/' && request.url !== 'Platform/App/GetAccessTokensFromCode/') {
      request.headers.set('Authorization', 'Bearer ' + bungieToken)
    }
    next()
  })
}

function configFirebase () {
  firebase.initializeApp(firebaseConfig)
  firebase.auth().onAuthStateChanged((user) => {
    store.commit('firebaseAuth/setUser', {user})
  })
}

function configAnalytics () {
  Vue.use(VueAnalytics, {
    id: process.env.ANALYTICS,
    router
  })
}

function configRaven () {
  if (process.env.RAVEN) {
    Raven
      .config(process.env.RAVEN)
      .addPlugin(RavenVue, Vue)
      .install()
  }
}

function hasCorrectUserCredentials () {
  return store.state.auth.membershipId && !isTokenExpired(store.state)
}

function configTokenExpirationWatcher () {
  setInterval(checkTokenExpired, 1000)
}

const created = function () {
  configureVueResource()
  configFirebase()
  configTokenExpirationWatcher()
  configAnalytics()
  configRaven()

  if (hasCorrectUserCredentials()) {
    store.dispatch('destiny/load')
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {App},
  created
})




// WEBPACK FOOTER //
// ./src/main.js